import { useEffect, useState } from 'react';
import type { FC } from 'react';
import gtm from '../../lib/gtm';
import { OnboardingTour } from './onboarding-tour';

/** Window event used to (re)launch the guided tour from anywhere. */
export const START_TOUR_EVENT = 'ipop:start-onboarding-tour';

/** Launch (or replay) the guided product tour from anywhere in the app. */
export const startOnboardingTour = (): void => {
    window.dispatchEvent(new Event(START_TOUR_EVENT));
};

/**
 * Always-mounted host for the guided tour so it can be replayed at any time —
 * independent of the onboarding checklist, which unmounts once complete.
 * Mounted once in DashboardLayout.
 */
export const OnboardingTourHost: FC = () => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const handler = () => {
            gtm.push({ event: 'onboarding_tour_started' });
            setOpen(true);
        };
        window.addEventListener(START_TOUR_EVENT, handler);
        return () => window.removeEventListener(START_TOUR_EVENT, handler);
    }, []);

    const handleClose = (completed?: boolean) => {
        if (completed) {
            gtm.push({ event: 'onboarding_tour_completed' });
        }
        setOpen(false);
    };

    return <OnboardingTour open={open} onClose={handleClose} />;
};
